import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

/**************************/
/* This is currently a stub service, but we'll need to buid this out eventually to support feature checks in business app
/**************************/

@Injectable({ providedIn: 'root' })
export class BusinessAppAccessService {
  hasAccessToFeature(_feature: string): Observable<boolean> {
    return of(true);
  }
  hasAccessToFeatures(_features: string[]): Observable<boolean> {
    return of(true);
  }
}
